<template lang="html">
  <div id="gallery-page">
    <div class="flex flex-wrap justify-between">
      <!-- Each rendering -->
      <div
        class="image"
        :class="{
          'w-third-l w-50-m w-100 vh-100-l vh-75': images.length === 3,
          'pa3 mr2': images.length > 3 && (index % 4) - 2 === 0,
          'hh': images.length > 3 && (index % 4) - 2 === 0,
          'w-100 w-100-m': images.length % 2 === 1 && index === images.length - 1
        }"
        :key="image.id"
        v-for="(image, index) in images"
        @click="openPopup(image)"
        :style="{'background-image': 'url(/static/img/' + image.rendering + '.jpg)'}"
      >
        <div class="overlay flex items-end justify-center">
          <div class="caption pv4" v-text="image.name"></div>
        </div>
      </div>
    </div>

    <!-- Image popup -->
    <transition name="fade" mode="out-in">
      <image-popup
        v-if="showPopup"
        :point="activeImage"
        @close="closePopup"
      />
    </transition>
  </div>
</template>

<script>
import ImagePopup from '@/components/Popup';

export default {
  name: 'gallery-page',
  data() {
    return {
      activeImage: undefined,
      images: [
        { id: 1, name: 'Courtyard', rendering: 'courtyard' },
        { id: 2, name: 'Exterior', rendering: 'exterior' },
        { id: 3, name: 'Rooftop', rendering: 'rooftop' }
      ],
      showPopup: false
    };
  },
  methods: {
    closePopup() {
      this.showPopup = false;
    },
    openPopup(image) {
      this.activeImage = image;
      this.showPopup = true;
    }
  },
  components: {
    'image-popup': ImagePopup
  }
};
</script>

<style lang="scss">
#gallery-page {
  position: relative;
  height: 100vh;
  width: 100vw;

  .image {
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    transition: opacity 0.2s ease-out;
    &:hover { opacity: 0.9; }
    &:active {
      opacity: 1;
      transition: opacity 0s ease-out;
    }

    .overlay {
      position: relative;
      width: 100%;
      height: 100%;
      background: -moz-linear-gradient(top, rgba(0,0,0,0) 53%, rgba(0,0,0,0.35) 100%);
      background: -webkit-linear-gradient(top, rgba(0,0,0,0) 53%,rgba(0,0,0,0.35) 100%);
      background: linear-gradient(to bottom, rgba(0,0,0,0) 53%,rgba(0,0,0,0.35) 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#59000000',GradientType=0 );

      .caption {
        color: #ffffff;
        font-weight: bold;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/GalleryPage/GalleryPage.vue